import { Component, Inject, InjectionToken, Input, ViewChild } from '@angular/core';
import {
  EmailService, IDraftEmail, SentEmail, IDraftEmailManagerFactory, IDraftEmailManagerItem, IEmailHandler,
  SentEmailListComponent, ReceivedEmailListComponent, EmailComposerComponent, EncounterDraftEmail, ReceivedEmail,
  BlockUI
} from '@harlowe/core';
import { EncounterService } from '../../../services/encounter.service';
import { Store } from '@ngxs/store';
import { DockModule } from 'primeng/dock';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PanelModule } from 'primeng/panel';
import { AsyncPipe, CommonModule, DatePipe, NgIf } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { instanceToInstance } from 'class-transformer';
import { UserInterface } from '../../../state/ui/ui-actions';
import { EmailState } from '../../../state/encounter-email/email-state';
import { EncounterDraftEmailManagerItem } from './encounter-draft-email-manager';

export const DRAFT_EMAIL_ITEM_FACTORY = new InjectionToken<string>('Draft_Email_Item_Factory');
@Component({
  selector: 'app-email-manager',
  standalone: true,
  imports: [DockModule, SentEmailListComponent, NgIf, ReceivedEmailListComponent, EmailComposerComponent,
    CommonModule, FormsModule, AsyncPipe, TabViewModule, TableModule, DatePipe,
    MenuModule, TagModule, PanelModule, ButtonModule, OverlayPanelModule, CheckboxModule, DropdownModule,
    DialogModule],
  templateUrl: './email-manager.component.html',
  styleUrl: './email-manager.component.scss'
})

export class EmailManagerComponent {

  @Input() emailHandler: IEmailHandler | undefined = undefined;
  @Input() sentEmails: SentEmail[] = [];

  selectedSection: 'drafts' | 'inbox' | 'sent' = 'sent';

  encounterDraftEmails$ = this._store.select(EmailState.encounterDraftEmails)
  receivedEmails$ = this._store.select(EmailState.receivedEmails);

  encounterDraftEmailItems: IDraftEmailManagerItem[] = [];

  receivedEmails: ReceivedEmail[] = [];
  unreadEmails: ReceivedEmail[] = [];

  selectedEmails: ReceivedEmail[] = [];

  draftEmail?: IDraftEmail = {} as IDraftEmail;

  newEmailDialogVisible: boolean = false;
  selectedDraft?: IDraftEmail;
  @ViewChild('draftEditor') draftEditor?: OverlayPanel;



  constructor
    (
      public _store: Store,
      private emailService: EmailService,
      private encounterService: EncounterService,
      @Inject(DRAFT_EMAIL_ITEM_FACTORY) private _draftEmailItemFactory: IDraftEmailManagerFactory,
    ) {
    this.encounterDraftEmails$.subscribe
      (
        drafts => {
          this.encounterDraftEmailItems = [];

          for (var draft of drafts) {
            this.encounterDraftEmailItems.push(this._draftEmailItemFactory.createDraftEmailManagerItem(draft));
          }
        }
      )

    this.receivedEmails$.subscribe
      (
        e => {
          this.receivedEmails = e;
        }
      )

    this.receivedEmails$.subscribe
      (
        e => {
          this.receivedEmails = e;
        }
      )

  }

  newDraftEmail() {
    this.draftEmail = {} as IDraftEmail
    this.draftEmail.recipients = [];
    this.draftEmail.ccs = [];
    this.draftEmail.bccs = [];
  }

  sendEmail(draftEmail: IDraftEmail) {
    this.emailHandler?.sendEmail(draftEmail).then(email => this.newEmailDialogVisible = false);
  }

  cancelEmail() {
    this.draftEmail = undefined;
  }

  draftSaved() {
    this.draftEmail = undefined;
  }

  passDraft(draft: IDraftEmail) {
    var clonedDraft = instanceToInstance(draft);

    clonedDraft.recipients = [...(clonedDraft.recipients || [])];
    clonedDraft.ccs = [...(clonedDraft.ccs || [])];
    clonedDraft.bccs = [...(clonedDraft.bccs || [])];
    clonedDraft.attachmentIds = [...(clonedDraft.attachmentIds || [])];

    return clonedDraft

  }

  async deleteButtonPressed(event: MouseEvent, emailId: number, draftType: string) {
    await this.emailService.deleteDraftEmail(emailId);
  }

  async sendDraft(draftEmail: IDraftEmail) {
    this._store.dispatch(new BlockUI.BlockUI());
    var draft: any = draftEmail;
    await this.encounterService.sendEncounterDraftEmail(draftEmail as EncounterDraftEmail).then(email => this.newEmailDialogVisible = false);
    this._store.dispatch(new BlockUI.UnBlockUI());
  }

  get sortedEmails(): ReceivedEmail[] {
    var sortedVals = this.receivedEmails.toSorted((a, b) => b.dateReceived.valueOf() - a.dateReceived.valueOf());
    return sortedVals ?? [];
  }

  get sortedReceivedEmails(): ReceivedEmail[] {
    var sortedVals = this.receivedEmails.toSorted((a, b) => b.dateReceived.valueOf() - a.dateReceived.valueOf());
    return sortedVals ?? [];
  }

  async emailViewed(email: ReceivedEmail) {
    if (!email.read)
      await this.emailService.readReceivedEmail(email.id);
  }

  async openEditor(email: EncounterDraftEmailManagerItem, event: MouseEvent) {
    this._store.dispatch(new BlockUI.BlockUI());

    this.selectedDraft = instanceToInstance(email.getDraftEmail());

    this._store.dispatch(new BlockUI.UnBlockUI());
    this.draftEditor?.toggle(event);
  }

  selectSection(section: 'drafts' | 'inbox' | 'sent') {
    this.selectedSection = section;
  }

  editorClosed() {
    this.selectedDraft = undefined;
  }
}
